import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { getLabel } from '../../data/labels';


function BetOptionsSection(props) {
	const betslipContext = useContext(BetslipContext) ;
	const rawData  = betslipContext.getBetOptionsData();
    const betOptionsData =rawData?  rawData : {freebets : [], funbonuses : []};    
    const checkedValue = betslipContext.getBetOptionsSelection();
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    
    let choosenFreebetName = '';
    let choosenFunbonusName = '';
    let amountFreebet = 0;
    let amountFunbonus = 0;
    
    for(let kb in betOptionsData.freebets){
		amountFreebet += betOptionsData.freebets[kb].importo;
		if(checkedValue?.type === 'freebet' && betOptionsData.freebets[kb].id_bonus == checkedValue.value){
			choosenFreebetName = betOptionsData.freebets[kb].sigla_promo + " " + checkedValue.value;
		}
    }
    
	for(let kb in betOptionsData.funbonuses){
		amountFunbonus += betOptionsData.funbonuses[kb].importo;
		if(checkedValue?.type === 'funbonus' && betOptionsData.funbonuses[kb].id_bonus == checkedValue.value){
			choosenFunbonusName = betOptionsData.funbonuses[kb].sigla_promo + " " + checkedValue.value;
		}
	}
    
    function handleChange(type){
    	if((type === 'freebet' && choosenFreebetName != '') || (type === 'funbonus' && choosenFunbonusName != '')){
    		betslipContext.setBetOptionsSelection('REAL', null)    	
    	}
    	else{
    		showOptions(type);
    	}
    
    }
    
    function showOptions(type){
    	function selectorFunction(value, type){
    		betslipContext.setBetOptionsSelection(value, type);
    	}
    	window.showBetOptionsModal(type === 'freebet'? betOptionsData.freebets : betOptionsData.funbonuses, type, checkedValue, selectorFunction);
    }
    
    const styleObj = props.isSinglebet? {'gridRow' : '2'} : {};
    return ( <>
	        <div className="bet-options-selectors-container" style={styleObj}>
	        {
	        	betOptionsData.freebets.length > 0 && <div className="betslip-container-switch-bet-option-selector">
	               <div className="customInput customInput--toggle bet-option-selector">
		                <label>
		                    <input id="freebetBtn" type="checkbox" onChange={() => handleChange('freebet')} checked={checkedValue && checkedValue.type === 'freebet'}></input>
		                    <span></span>
		            	<div className="customInput__description" onClick={() => {showOptions('freebet')}}> {choosenFreebetName !== ''? choosenFreebetName : getLabel('mybets.freebet') + " " + getCurrencyValue(amountFreebet, mult, nDec, currency)}</div>
		               </label>
	              </div>
	        	</div>
	        }
	        {
	        	betOptionsData.funbonuses.length > 0 && <div className="betslip-container-switch-bet-option-selector">
	               <div className="customInput customInput--toggle bet-option-selector">
		                <label className="customInput customInput--toggle bet-option-selector">
		                    <input id="funbonusBtn" type="checkbox" onChange={() =>  handleChange('funbonus')} checked={checkedValue && checkedValue.type === 'funbonus'}></input>
		                    <span></span>
		            	<div className="customInput__description" onClick={() => {showOptions('funbonus')}}> {choosenFunbonusName !== ''? choosenFunbonusName : getLabel('mybets.funbonus') + " " + getCurrencyValue(amountFunbonus, mult, nDec, currency)}</div>
		                </label>
	               </div>
	        	</div>
	        }
        </div>
    </>
    );
}

export default BetOptionsSection;